/* eslint-disable */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, putData } from "utils/Gateway";

const AssignCompanyPopup = ({
  selectedFaqId = null,
  setSelectedFaqId = () => {},
  afterPopupClose = () => {},
}) => {
  const token = localStorage.getItem("token");

  const { t } = useTranslation();

  const [companyLoading, setCompanyLoading] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [faqCompanies, setFaqCompanies] = useState([]);

  const [companyName, setCompanyName] = useState("");

  const [checkedCompanies, setCheckedCompanies] = useState({}); // To store checked state

  const [isSaving, setisSaving] = useState(false);

  const [validation, setValidation] = useState({
    companyError: false,
  });

  //validation function
  const validationHandler = () => {
    let isValid = true;

    if (faqCompanies.length === 0) {
      setValidation((prevState) => ({ ...prevState, companyError: true }));
      isValid = false;
    }

    return isValid;
  };

  //function for get company list
  const getAllCompanyList = async (isLoading = false, titleString = "") => {
    try {
      if (isLoading) {
        setCompanyLoading(true);
      }

      let requestURL =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY +
        `?token=${token}&modulefrom=backend`;

      if (titleString !== "") {
        requestURL += `&filtername=${titleString}`;
      }

      const response = await getData(requestURL);

      setCompanyLoading(false);

      console.log(response);

      if (response.status) {
        setCompanyList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for check expert
  const companyCheckHandler = (companyId, isChecked) => {
    setCheckedCompanies((prevState) => ({
      ...prevState,
      [companyId]: isChecked, // Update checked state for the specific expert
    }));

    if (isChecked) {
      // Add to faqExperts if checked, if not already there
      if (!faqCompanies.includes(companyId)) {
        setFaqCompanies((prevState) => [...prevState, companyId]);
      }
    } else {
      // Remove from faqExperts if unchecked
      setFaqCompanies((prevState) =>
        prevState.filter((id) => id !== companyId)
      );
    }
  };

  //get faq details
  const getFaqDetails = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_FAQ_DETAILS +
        `/${selectedFaqId}?token=${token}`;

      const response = await getData(requestURL);

      if (response.status) {
        const data = response.data;

        if (data.companyids && data.companyids.length > 0) {
          for (let cpmanyId of data.companyids) {
            companyCheckHandler(cpmanyId, true);
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //save faq function
  const saveFaqHandler = async (e) => {
    if (validationHandler()) {
      try {
        setisSaving(true);

        let apiData = {
          companyids: faqCompanies,
        };

        let requestURL = url.API_BASE_URL;

        let response = {};

        if (selectedFaqId) {
          requestURL += url.API_UPDATE_FAQ + `/${selectedFaqId}?token=${token}`;

          response = await putData(requestURL, apiData);
        }

        setisSaving(false);

        console.log(response);

        if (response.status) {
          // close the popup
          let offCanvasPopup = document.querySelector(
            "#offcanvasAssignCompany"
          );
          let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
          offCanvas.hide();

          resetHandler();
          afterPopupClose();
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  const resetHandler = () => {
    setCompanyList([]);
    setFaqCompanies([]);
    setCompanyName("");
    setCheckedCompanies({});
    setSelectedFaqId(null);

    setValidation({
      companyError: false,
    });
  };

  useEffect(() => {
    if (selectedFaqId) {
      getAllCompanyList(true);
      getFaqDetails();
    }
  }, [selectedFaqId]);

  useEffect(() => {
    if (companyName !== "" && companyName.length > 0) {
      const filterSearch = companyList.filter((company) =>
        company.name.toLowerCase().includes(companyName.toLowerCase())
      );

      if (filterSearch.length === 0) {
        getAllCompanyList(false, companyName);
      }
    } else {
      const timeoutId = setTimeout(() => {
        getAllCompanyList(false);
      }, 500); // Debounce the input for better UX
      return () => clearTimeout(timeoutId);
    }
  }, [companyName]);

  // Filtered list based on search input if length > 2
  const filteredCompanies =
    companyName.length > 2
      ? companyList.filter((company) =>
          company.name.toLowerCase().includes(companyName.toLowerCase())
        )
      : companyList;

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="offcanvasAssignCompany"
      aria-labelledby="offcanvasAssignCompanyLabel"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              business
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasAssignCompanyLabel"
            >
              {t("Assign Sponsors")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Manage sponsors for this FAQ")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="search position-relative">
                  <button className="d-block position-absolute top-50 border-0 text-primary material-symbols-outlined bg-transparent ms-3 translate-middle-y">
                    search
                  </button>
                  <input
                    type="text"
                    className="form-control fs-sm shadow-none border border-gray-300 ps-5"
                    placeholder="Search content by name"
                    id="companySearch"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                  />
                  {validation.companyError && (
                    <div className="text-danger mt-2">
                      Please select at least one company.
                    </div>
                  )}
                </div>
              </div>

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="question"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Sponsors")}
                </label>
                <ul
                  className="experts list-unstyled mb-0"
                  id="appcourses"
                  style={{ maxHeight: "250px", overflowY: "auto" }}
                >
                  {companyLoading
                    ? [1, 2, 3, 4].map((_, index) => (
                        <li
                          key={index}
                          className="px-3 py-3 d-flex align-items-center gap-3 border-bottom border-gray-200"
                        >
                          <div className="placeholder-glow w-100">
                            <span
                              className="placeholder col-2 me-2 rounded-circle"
                              style={{ width: "2.2rem", height: "2.2rem" }}
                            ></span>
                            <span className="placeholder col-6"></span>
                          </div>
                        </li>
                      ))
                    : filteredCompanies.map((company) => (
                        <li
                          key={company._id}
                          className="expert-item px-3 py-3 d-flex align-items-center gap-3 border-bottom border-gray-200 bg-white rounded-3 transition"
                        >
                          {/* Checkbox */}
                          <input
                            type="checkbox"
                            className="form-check-input flex-shrink-0 border-2 shadow-none m-0 me-2"
                            id={`expert_checkbox_${company._id}`}
                            checked={!!checkedCompanies[company._id]}
                            value={company._id}
                            onChange={(e) =>
                              companyCheckHandler(company._id, e.target.checked)
                            }
                          />

                          {/* User Info */}
                          <div className="flex-grow-1">
                            <p className="mb-0 fw-semibold text-dark">
                              {company.name}
                            </p>
                          </div>

                          {/* Details Link */}
                          <Link
                            to={`${url.FRONTEND_BASE_URL}/companies/details/${company._id}`}
                            className="text-primary d-flex align-items-center gap-1 ms-auto fw-semibold"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <span>Details</span>
                            <span className="material-symbols-outlined fs-6">
                              chevron_right
                            </span>
                          </Link>
                        </li>
                      ))}
                </ul>
              </div>
            </div>

            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                onClick={saveFaqHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Faq")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AssignCompanyPopup;
